
import formularmodal from '~/mixins/formularmodal';
export default {
  mixins: [formularmodal],
  props: [],
  data() {
    return {
      modal: {
        event: 'formular::anbaugeraete',
        titel: null,
        modelname: 'Anbaugerät',
        model: 'anbaugeraete',
      },
      model: null,
      spezialfelder: [
        {
          name: 'Ausbringmenge in m³',
          key: 'menge_m3',
          anzeigen: false
        },
        {
          name: 'Pflanzenschutzmittel',
          key: 'pflanzenschutzmittel',
          anzeigen: false
        }
      ]
    }
  },
  computed: {
    spezialfelderKeyVal() {
      return this.spezialfelder.reduce((obj, feld) => {
        obj[feld.key] = false;
        return obj;
      }, {});
    }
  },
  watch: {},
  methods: {
    fillModel(model = null) {
      if (!model) model = {};
      let empty = {
        name: ''
      };
      model = this.$fillMissing(model, empty);
      model.spezialfelder = this.$fillMissing(model.spezialfelder, this.$copy(this.spezialfelderKeyVal));
      this.model = model;
    }
  },

}
